import { React } from "react";
import data from "../data/about-data.js";

const About = () => {
  return (
    <div className="page-container about-page">
      <p className="main-heading">About Us</p>
      <p className="paragraph">
        Indelect Technologies Pvt.Ltd. established in the year 1995 by the
        Technocrats having over 18 years of combined expertise in technology and
        mentoring experience in advanced areas of Biomedical Engineering,
        Medical Imaging Technology & Power Electronics. Indelect, over these
        years has acclaimed a high reputation in the international markets apart
        from serving the domestic Indian market. With a sustainable and
        consistently growing progress, Indelect Technologies Pvt. Ltd. has
        evolved into a dominant player in the distribution of Biomedical,
        Medical Imaging & Power Electronic equipments. The organization has
        expanded vastly in its length and breadth and has its foot firmly
        grounded to diverse activities.
      </p>
      <p className="sub-heading">Indelect's Journey</p>
      <div className="timeline-container">
        <ul className="timeline-list timeline-list-nodots">
          {data.map((item) => (
            <li key={item.id} className="timeline-item-nodot">
              <span className="timeline-year-nodot">{item.year}</span>
              <span className="timeline-desc-nodot">{item.description}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default About;